import { collection, addDoc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

// Create Stripe Checkout session
export const createCheckoutSession = async (userId, priceId) => {
  try {
    const checkoutSessionRef = await addDoc(
      collection(db, 'customers', userId, 'checkout_sessions'),
      {
        price: priceId,
        success_url: window.location.origin + '/?payment=success',
        cancel_url: window.location.origin + '/?payment=cancel',
        trial_period_days: 7,
        allow_promotion_codes: true,
      }
    );

    // Listen for the checkout URL
    return new Promise((resolve, reject) => {
      const unsubscribe = onSnapshot(checkoutSessionRef, (snap) => {
        const data = snap.data();
        if (data?.error) {
          unsubscribe();
          reject(new Error(data.error.message));
        }
        if (data?.url) {
          unsubscribe();
          resolve(data.url);
        }
      });
    });
  } catch (error) {
    console.error('Error creating checkout session:', error);
    throw error;
  }
};

// Create Customer Portal session (for managing subscription)
// Uses our Cloud Function since the Stripe extension doesn't support portal links via Firestore
export const createPortalLink = async (userId) => {
  try {
    // Call our Cloud Function to create the portal session
    const response = await fetch('https://createcustomerportal-56qixrx7ka-uc.a.run.app', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        userId,
        returnUrl: window.location.origin
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to create portal link');
    }

    const data = await response.json();
    return data.url;
  } catch (error) {
    console.error('Error creating portal link:', error);
    throw error;
  }
};
